export default __webpack_public_path__ + "static/media/img-guide-gt-popup-4-es_es.b5ce78ac.png";